module.exports = __webpack_public_path__ + "img/avatar6.1a78cab2.png";